import { LifecycleTracker } from '@/infra/lifecycle-tracker'
import { computed, observable, runInAction } from 'mobx'
import type RelationManager from '@/features/relation-manager/RelationManager'
import { Id } from '@/infra/id'
import type { FetchRelationManagerFn } from '@/features/relation-manager'
import type { GetCurrentWorkspaceFn } from '@/features/iam'
import { ignoreAbortError } from '@/utils/abort-util'
import { NotFound } from 'fejl'
import { type JobType, TaxJobType } from '@/features/jobs/job-type'

export class JobDetailsRelationManagerViewModel {
  private readonly _lifecycle = new LifecycleTracker()

  @observable
  public accessor relationManager: RelationManager | null = null

  constructor(
    private readonly jobId: Id,
    private readonly jobType: JobType,
    private readonly fetchRelationManager: FetchRelationManagerFn,
    private readonly getCurrentWorkspace: GetCurrentWorkspaceFn,
  ) {}

  @computed
  get isEnabled() {
    return this.getCurrentWorkspace().config.agents.enabled
  }

  /** @inheritDoc */
  activate() {
    this._lifecycle.activate()

    if (this.isEnabled && this.jobType instanceof TaxJobType) {
      void this.getRelationManager(this._lifecycle.signal).catch(
        ignoreAbortError,
      )
    }
  }

  /** @inheritDoc */
  deactivate() {
    this._lifecycle.deactivate()
  }

  async getRelationManager(signal?: AbortSignal) {
    const relationManager = await this.fetchRelationManager(
      Id.assert(this.jobId),
    ).catch(NotFound.ignore(null))

    signal?.throwIfAborted()

    runInAction(() => (this.relationManager = relationManager))
  }
}
